/**
 * Disarm any press that React Aria armed on the element the sheet drag started from.
 *
 * React Aria's `usePress` arms a press on pointer down and only decides on pointer up, cancelling
 * in between when the browser sends `pointercancel` — which is what stops a native scroll from
 * activating the control under the finger. A sheet drag is driven in JS, so the browser never
 * claims the pointer, and the sheet moves with the finger so the pointer never leaves the control
 * either. Without the event below, dragging the sheet from a checkbox toggles it on release.
 *
 * `usePress` listens for `pointercancel` on the document, so the event has to bubble from the
 * original touch target.
 */
const cancelPressOnDragStart = (touchTarget: EventTarget | null): void => {
    if (!(touchTarget instanceof Element)) return;

    const PointerEventConstructor = touchTarget.ownerDocument.defaultView?.PointerEvent;
    if (!PointerEventConstructor) return;

    touchTarget.dispatchEvent(
        new PointerEventConstructor('pointercancel', { bubbles: true, cancelable: false, pointerType: 'touch' }),
    );
};

export default cancelPressOnDragStart;
